import React, { useRef, useEffect, useState, useContext,createRef } from 'react'
import user from '../../assets/images/user.png'
import close_btn from '../../assets/images/close-btn.png'
import { useDispatch, useSelector } from 'react-redux'
import { setGroupInfoDrawer, setNewGroupDrawer, setNewGroupRightDrawer, setGroupUpdateDrawer } from '../../redux/actions/drawerActions'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen } from '@fortawesome/free-solid-svg-icons';
import AddGroupMemberRight from "./AddGroupMemberRight"
import SocketContext from '../../context/SocketContext'
import GroupUpdate from "./GroupUpdate"
function GroupInfo({ currChat, reportConversation, exitGroup,drawer }) {

    const { isAddGroupOpen, isNewGroupOpen } = useSelector(state => state.drawer);
    const dispatch = useDispatch();

    const groupMembers = useSelector(state => state.conversation.groupMembers);
    const addGroupDrawerRightRef = useRef(null);
    const addGroupUpdateDrawerRef = useRef(null);
    const { isNewGroupRightOpen } = useSelector(state => state.drawer);
    const { isGroupUpdateOpen } = useSelector(state => state.drawer);
    const [userId, setUserId] = useState(null);
    const socket = useContext(SocketContext);

    const [IsRemoved, setIsRemoved] = useState(null)
    useEffect(() => {
        const userData = localStorage.getItem("userData");

        if (userData) {
            try {
                const userData1 = JSON.parse(userData);
                setUserId(userData1?.id);
            } catch (error) {
                console.error("Error parsing userData from localStorage:", error);
            }
        }
    }, []);
    const isAdmin = groupMembers.some(member => member.user_id === userId && member.admin === "1");
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (addGroupDrawerRightRef.current && !addGroupDrawerRightRef.current.contains(event.target) && !addGroupUpdateDrawerRef.current.contains(event.target)) {
                dispatch(setNewGroupRightDrawer(false));
                dispatch(setGroupUpdateDrawer(false))
            }

        };
        if (isNewGroupRightOpen || isGroupUpdateOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isNewGroupRightOpen, isGroupUpdateOpen]);
    const exit_group = () => {
        exitGroup();
        dispatch(setGroupInfoDrawer(false))

    }
    const remove_member = (data) => {
        const removed = data.is_removed === "1"

        setIsRemoved(removed)
    }
    useEffect(() => {
        if (socket) {
            socket.on("remove_member", remove_member);
            return () => {
                socket.off("remove_member", remove_member);
            };
        }
    }, [socket]);
    const messagesEndRef = createRef(null);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView();
    };
    useEffect(()=>{scrollToBottom()},[drawer])
    return (
        <>
            <div className="profile-info-box">
                <div className="profile-header">
                    <div className="close-btn" onClick={() => dispatch(setGroupInfoDrawer(false))}>
                        <img src={close_btn} alt="close btn" id="closeBtn" />
                    </div>
                    <div className="user-info">
                        <h5>Group Info</h5>
                    </div>
                </div>
                <div className="profile-detail-box">
                    <div className="profile-img-box">
                        <div className="profile-img">
                            <img alt="user profile image" src={currChat?.group_icon || user} />
                        </div>
                        <div className="group-name">
                            <p className="user-name">{currChat?.group_name}</p>
                            {isAdmin && (<i onClick={() => dispatch(setGroupUpdateDrawer(true))}> <FontAwesomeIcon icon={faPen} /> </i>)}

                        </div>
                        <div className="group-members">
                            <span>
                                Group: <span> {groupMembers.length} members</span>
                            </span>
                        </div>
                    </div>
                    <>
                        {currChat.conv_type == 2 && isAdmin && !IsRemoved ? (
                            <div className="setting-box">
                                <ul>
                                    <li
                                        onClick={() => {
                                            dispatch(setNewGroupRightDrawer(true));
                                        }}
                                    >
                                        <a>
                                            <div className="img-box">
                                                <i>
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        style={{
                                                            width: '35px',
                                                            height: '35px',
                                                            color: 'white',
                                                            cursor: 'pointer',
                                                        }}
                                                    />
                                                </i>
                                            </div>
                                            <div
                                                className="setting-tab"
                                            >
                                                Add Member
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        ) : null}
                    </>
                    <div className="group-member-box">
                        <p>{groupMembers.length} members</p>
                        <nav className="user-chat-nav scroll-group" id="scrollbar">
                        <div ref={messagesEndRef}></div> 
                            {groupMembers && groupMembers.length > 0 ? (
                                groupMembers.map((member) => {
                                    const isSelf = member.user_id === userId;
                                    const isAdmin1 = member.admin === "1";
                                    return (
                                        <div className="nav-link" key={member.user_id}>
                                            <div className="user-chat-box">
                                                <a className="d-flex align-items-center">
                                                    <div className="img-box">
                                                        <img
                                                            src={member.profile_pic && member.profile_pic.trim() !== "" ? member.profile_pic : user}
                                                            alt={member.username}
                                                        />
                                                    </div>
                                                    <div className="user-info text-start">
                                                        <h5>{isSelf ? 'You' : member.username}</h5>
                                                        {isAdmin1 && <span className="admin-label">Admin</span>}
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <p>No members found</p>
                            )}
                        </nav>
                    </div>

                    <div className="setting-box">
                        <ul>
                            {((currChat.is_removed == undefined || currChat.is_removed == 0)) && (
                                <li onClick={exit_group}>
                                    <a href="#">
                                        <div className="img-box">
                                            <svg
                                                width={35}
                                                height={35}
                                                viewBox="0 0 35 35"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M17.5 0C7.85046 0 0 7.85046 0 17.5C0 27.1495 7.85046 35 17.5 35C27.1495 35 35 27.1495 35 17.5C35 7.85046 27.1495 0 17.5 0ZM23.1546 24.2704C21.3317 26.1138 18.9004 27.129 16.3085 27.129C10.999 27.129 6.67939 22.8095 6.67939 17.5C6.67939 12.1905 10.999 7.87097 16.3085 7.87097C18.9004 7.87097 21.3317 8.88617 23.1546 10.7296C23.4731 11.0517 23.4702 11.5711 23.1481 11.8896C22.8259 12.2082 22.3065 12.2053 21.988 11.8831C20.4757 10.3538 18.4587 9.51159 16.3085 9.51159C11.9036 9.51159 8.32009 13.0952 8.32009 17.5C8.32009 21.9048 11.9037 25.4884 16.3085 25.4884C18.4587 25.4884 20.4757 24.6462 21.988 23.1168C22.3066 22.7947 22.8259 22.7917 23.1481 23.1103C23.4702 23.4289 23.4732 23.9483 23.1546 24.2704ZM28.0803 18.08L25.2043 20.956C25.0441 21.1161 24.8342 21.1963 24.6243 21.1963C24.4143 21.1963 24.2044 21.1162 24.0442 20.956C23.7239 20.6356 23.7238 20.1162 24.0442 19.7958L25.5199 18.3203H16.3085C15.8555 18.3203 15.4882 17.953 15.4882 17.5C15.4882 17.047 15.8555 16.6797 16.3085 16.6797H25.5198L24.0442 15.2042C23.7239 14.8838 23.7238 14.3644 24.0442 14.044C24.3646 13.7236 24.884 13.7236 25.2044 14.044L28.0803 16.9199C28.2341 17.0737 28.3206 17.2824 28.3206 17.4999C28.3206 17.7175 28.2341 17.9262 28.0803 18.08Z"
                                                    fill="#E63030"
                                                />
                                            </svg>
                                        </div>
                                        <div className="setting-tab red">Exit group</div>
                                    </a>
                                </li>
                            )}

                            <li onClick={() => reportConversation()}>
                                <a href="#">
                                    <div className="img-box">
                                        <svg
                                            width={35}
                                            height={35}
                                            viewBox="0 0 35 35"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clipPath="url(#clip0_1633_1814)">
                                                <path
                                                    d="M17.5 0C14.0388 0 10.6554 1.02636 7.77753 2.94928C4.89967 4.87221 2.65665 7.60533 1.33212 10.803C0.00758243 14.0007 -0.338976 17.5194 0.336265 20.9141C1.01151 24.3088 2.67822 27.427 5.12564 29.8744C7.57306 32.3218 10.6913 33.9885 14.0859 34.6637C17.4806 35.339 20.9993 34.9924 24.197 33.6679C27.3947 32.3434 30.1278 30.1003 32.0507 27.2225C33.9737 24.3446 35 20.9612 35 17.5C35 12.8587 33.1563 8.40752 29.8744 5.12563C26.5925 1.84374 22.1413 0 17.5 0ZM20.8457 18.2622C20.8457 19.6438 16.427 22.1951 16.1898 23.5582C16.0424 24.4378 16.2382 26.699 15.6303 26.699C14.5987 26.699 13.2747 26.303 13.2747 24.0118C13.2747 21.9901 14.5987 19.3674 14.5987 19.3674H9.24047C8.86554 19.3673 8.50376 19.2293 8.22409 18.9796C7.94443 18.7299 7.76642 18.386 7.72402 18.0135C7.68162 17.6409 7.77778 17.2658 7.99417 16.9597C8.21057 16.6535 8.53206 16.4376 8.89738 16.3533C8.67723 16.1731 8.51179 15.9351 8.41972 15.6659C8.32765 15.3968 8.31261 15.1073 8.3763 14.83C8.43998 14.5528 8.57985 14.2989 8.78015 14.0969C8.98044 13.8949 9.23318 13.7529 9.50988 13.6868C9.28553 13.5082 9.11613 13.2698 9.02116 12.9992C8.92618 12.7286 8.90948 12.4367 8.97297 12.157C9.03646 11.8773 9.17756 11.6212 9.38007 11.4181C9.58257 11.215 9.83827 11.0732 10.1178 11.0089C9.87201 10.8108 9.69356 10.5416 9.60693 10.238C9.5203 9.93453 9.52973 9.61164 9.63392 9.31369C9.73811 9.01575 9.93196 8.75735 10.1889 8.57397C10.4458 8.39059 10.7531 8.29121 11.0688 8.28947L19.7313 8.38618C20.0265 8.3874 20.3092 8.50521 20.518 8.71395C20.7267 8.92269 20.8445 9.20545 20.8457 9.50066V18.2622ZM27.2931 18.2622C27.2913 18.5582 27.1727 18.8415 26.9632 19.0507C26.7536 19.2598 26.47 19.3777 26.174 19.379H23.0954C22.799 19.3783 22.5148 19.2606 22.3048 19.0515C22.0947 18.8423 21.9758 18.5586 21.974 18.2622V9.50066C21.9764 9.20464 22.0956 8.92153 22.3056 8.71285C22.5155 8.50417 22.7994 8.38678 23.0954 8.38618H26.1671C26.4629 8.38679 26.7465 8.50425 26.9561 8.71299C27.1657 8.92174 27.2844 9.20485 27.2862 9.50066L27.2931 18.2622Z"
                                                    fill="#E63030"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1633_1814">
                                                    <rect width={35} height={35} fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div className="setting-tab red">Report group</div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div >
            <div ref={addGroupDrawerRightRef} className={`drawer ${isNewGroupRightOpen ? 'open' : ''}`}>
                <AddGroupMemberRight drawer={isNewGroupRightOpen} />
            </div>
            <div ref={addGroupUpdateDrawerRef} className={`drawer ${isGroupUpdateOpen ? 'open' : ''}`}>
                <GroupUpdate />
            </div>
        </>



    )
}

export default GroupInfo